// extracted by mini-css-extract-plugin
export default {"loadingBird":"LoadingComp_loadingBird__FuAyD"};